import * as React from "react";

var Date = require("antd/lib/date-picker").default;
var locale = require("antd/es/date-picker/locale/en_US").default;
require("antd/lib/date-picker/style");

function InputDate(props) {
  const {
    label,
    error,
    helperText,
    leftElement,
    rightElement,
    registration,
    id,
    width = "w-18",
    height = "h-8",
    placeholder = "날짜선택",
    ...restProps
  } = props;

  const inputProps = {
    // ref: ref,
    id: id,
    ...restProps,
    ...registration,
  };
  return (
    <div className="relative">
      <Date
        placeholder={placeholder}
        locale={{
          lang: {
            ...locale.lang,
            today: "확인",
          },
        }}
        className={`relative text-secondary-grey border border-button-grey rounded-[4px] p-[6px] focus:outline-none  ${width} ${height}`}
        {...inputProps}
      />
    </div>
  );
}

export default InputDate;
